import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import * as cls from "./modalDeadLock.module.scss";
import { DialogTitle } from "@mui/material";
import { Button } from "../../../personal-studio-components/form";

export default function ModalMessage({
  title,
  message,
  open,
  setOpen,
  onClose,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="responsive-dialog-title"
      classes={{ paper: cls.dialog_paper }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <p> {message}</p>
      </DialogContent>
      <div>
        <DialogActions classes={{ paper: cls.dialogContnent }}>
          <Button type="primary" onClick={handleClose}>
            Закрыть
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}
